var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWildfire(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fill_Outline",
    "data-name": "Fill Outline"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke_copy",
    "data-name": "Stroke copy"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m59.284 17.72 1.716-5.72a20.118 20.118 0 0 0 -9 9c-.07.141-.132.286-.2.427a23.389 23.389 0 0 0 -1.23-4 4.051 4.051 0 0 0 -2.274-2.11 4.137 4.137 0 0 1 -2.42-4.822l1.124-4.495-6.479 5.039a4.138 4.138 0 0 0 -1.263 4.9l.871 2.033a4.137 4.137 0 0 1 -.334 3.885l-1.095 1.683a1.117 1.117 0 0 1 -2.024-.863 9.051 9.051 0 0 0 -3.831-9.36 3.938 3.938 0 0 1 -1.618-3.587l.773-7.73-7.383 7.383a4.039 4.039 0 0 0 -.434 5.346 3.938 3.938 0 0 1 .217 4.671l-1.4 2.1-1.125-1.406a4.744 4.744 0 0 0 -2.2-1.537 4.744 4.744 0 0 1 -2.942-6.167l1.267-3.39-7.383 7.383a4.039 4.039 0 0 0 -.434 5.346 3.938 3.938 0 0 1 .217 4.671l-1.323 1.984c-.274-.546-.54-1.1-.841-1.631l-3.236-5.753-1.615 13.729a14.774 14.774 0 0 0 3.629 11.537l5.986 6.734 18-6 15 1 10-3 3.616-10.848a12.354 12.354 0 0 0 -.177-8.313 12.643 12.643 0 0 1 -.155-8.119z",
    fill: "#f89c8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.509 44.937a12.724 12.724 0 0 1 -2.571-4.445 12.862 12.862 0 0 1 -.567-5.53l.9-7.628.224.4c.225.4.428.808.631 1.216l1.709 3.4 3.234-4.849a5.909 5.909 0 0 0 -.332-7.037 2.061 2.061 0 0 1 .3-2.671l2.506-2.505a6.791 6.791 0 0 0 .547 1.668 6.682 6.682 0 0 0 3.955 3.494 2.741 2.741 0 0 1 1.274.889l2.834 3.542 2.92-4.38a5.909 5.909 0 0 0 -.332-7.037 2.061 2.061 0 0 1 .3-2.671l3.421-3.421-.216 2.155a5.956 5.956 0 0 0 2.439 5.409 7.033 7.033 0 0 1 3.054 7.283 3.086 3.086 0 0 0 .576 2.636 3.186 3.186 0 0 0 2.478 1.194 3.088 3.088 0 0 0 2.593-1.424l1.1-1.686a6.125 6.125 0 0 0 .495-5.764l-.881-2.027a2.141 2.141 0 0 1 .653-2.531l2.018-1.569a6.093 6.093 0 0 0 3.759 6.116 2.188 2.188 0 0 1 1.195 1.027 21.46 21.46 0 0 1 1.124 3.658l1.226 5.687 2.714-5.636a18.139 18.139 0 0 1 3.637-4.939l-.058.189a14.712 14.712 0 0 0 .2 9.407 10.381 10.381 0 0 1 .149 6.968l-3.288 9.863-8.66 2.6-15.031-1-17.12 5.698z",
    fill: "#f8664f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.021 29.144a2.984 2.984 0 0 0 5.01 2.567 39.352 39.352 0 0 0 5.956-7.133 9.124 9.124 0 0 0 1.476-4.71 8.054 8.054 0 0 1 1.474 2.705l.806 3.746a3.649 3.649 0 0 0 6.853.818c.045.13.09.259.136.387a7.6 7.6 0 0 1 .141 5.047l-2.795 8.386-6.648 1.994-15.078-1.005-15.8 5.268-3.8-4.271a9.772 9.772 0 0 1 -2.29-4.613 9.648 9.648 0 0 1 -.154-2.459 2.453 2.453 0 0 0 .465.042 2.586 2.586 0 0 0 2.1-1.206l3.694-5.537a8.9 8.9 0 0 0 1.274-6.97 35.574 35.574 0 0 1 6.111 5.993l1.415 1.769 2.17-2.791a19.04 19.04 0 0 0 3.437-7.064l1.026-4.107a19.037 19.037 0 0 1 3.021 13.144z",
    fill: "#cc5144"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24 28 17 25h-34z",
    fill: "#5ba006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 28 17 25h-34z",
    fill: "#5ba006"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#7ab92d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 53h-12l6-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 48h-10l5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 44h-8l4-6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7 53h4v5h-4z",
    fill: "#e59730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.875 45h6.25l-.625-1h-5z",
    fill: "#5ba006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.4 49h7.2l-.6-1h-6z",
    fill: "#5ba006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 53v2a2 2 0 0 1 2 2v1h2v-5z",
    fill: "#b27525"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41 53h4v5h-4z",
    fill: "#b27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 53h4v5h-4z",
    fill: "#b27525"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#7ab92d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61 53h-12l6-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 48h-10l5-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 44h-8l4-6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m53 53h4v5h-4z",
    fill: "#e59730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.875 45h6.25l-.625-1h-5z",
    fill: "#5ba006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.4 49h7.2l-.6-1h-6z",
    fill: "#5ba006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 53v2a2 2 0 0 1 2 2v1h2v-5z",
    fill: "#b27525"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m57 53h-20l10.001-14z",
    fill: "#c4f236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55 44h-16l8-12z",
    fill: "#c4f236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 53h4v8h-4z",
    fill: "#fcbc04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53 35h-12l6-8z",
    fill: "#c4f236"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a1d51c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48 33a3 3 0 0 1 -2.977-3.363l-4.023 5.363h12l-1.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.474 41a4 4 0 0 1 -3.99-3.726l-4.484 6.726h16l-2-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.773 50a4 4 0 0 1 -3.7-5.5l-6.073 8.5h20l-2.143-3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m47 57a2 2 0 0 1 2-2v-2h-4v8h2z",
    fill: "#e59730"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27 53h-20l10.001-14z",
    fill: "#c4f236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 44h-16l8-12z",
    fill: "#c4f236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 53h4v8h-4z",
    fill: "#fcbc04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23 35h-12l6-8z",
    fill: "#c4f236"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a1d51c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18 33a3 3 0 0 1 -2.977-3.363l-4.023 5.363h12l-1.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.474 41a4 4 0 0 1 -3.99-3.726l-4.484 6.726h16l-2-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.773 50a4 4 0 0 1 -3.7-5.5l-6.073 8.5h20l-2.143-3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m17 57a2 2 0 0 1 2-2v-2h-4v8h2z",
    fill: "#e59730"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m42 53h-20l10.001-14z",
    fill: "#c4f236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 44h-16l8-12z",
    fill: "#c4f236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 53h4v8h-4z",
    fill: "#fcbc04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 35h-12l6-8z",
    fill: "#c4f236"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#a1d51c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33 33a3 3 0 0 1 -2.977-3.363l-4.023 5.363h12l-1.5-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.474 41a4 4 0 0 1 -3.99-3.726l-4.484 6.726h16l-2-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.773 50a4 4 0 0 1 -3.7-5.5l-6.073 8.5h20l-2.143-3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m32 57a2 2 0 0 1 2-2v-2h-4v8h2z",
    fill: "#e59730"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Stroke_Cut_copy_2",
    "data-name": "Stroke Cut copy 2"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#323232"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.511 40.039a.976.976 0 0 0 .176-.016 1 1 0 0 0 .813-1.159 13.807 13.807 0 0 1 -.118-4.018l1.253-10.679 1.73 3.077c.233.413.443.836.654 1.259l.165.33a1 1 0 0 0 1.725.105l1.326-1.988a4.914 4.914 0 0 0 -.276-5.851 3.041 3.041 0 0 1 .365-4.009l4.226-4.226a5.748 5.748 0 0 0 3.8 6.642 3.73 3.73 0 0 1 1.75 1.213l1.125 1.406a1.021 1.021 0 0 0 .823.374 1 1 0 0 0 .789-.444l1.4-2.105a4.914 4.914 0 0 0 -.276-5.851 3.041 3.041 0 0 1 .365-4.009l5.4-5.4-.495 4.943a4.952 4.952 0 0 0 2.029 4.5 8.012 8.012 0 0 1 3.44 8.316 2.117 2.117 0 0 0 3.836 1.635l1.1-1.686a5.128 5.128 0 0 0 .414-4.824l-.871-2.032a3.139 3.139 0 0 1 .959-3.713l4.191-3.261-.421 1.685a5.107 5.107 0 0 0 3.005 5.988 3.1 3.1 0 0 1 1.735 1.569 22.444 22.444 0 0 1 1.176 3.828 1 1 0 0 0 1.878.224l.2-.415a19.257 19.257 0 0 1 6.418-7.3l-.987 3.29a13.71 13.71 0 0 0 .179 8.762 11.4 11.4 0 0 1 .163 7.641l-.933 2.8a1 1 0 1 0 1.9.633l.932-2.8a13.394 13.394 0 0 0 -.19-8.986 11.7 11.7 0 0 1 -.132-7.475l1.716-5.72a1 1 0 0 0 -1.405-1.182 21.276 21.276 0 0 0 -8.434 7.65c-.189-.588-.4-1.159-.625-1.709a5.047 5.047 0 0 0 -2.823-2.651 3.119 3.119 0 0 1 -1.835-3.656l1.124-4.5a1 1 0 0 0 -1.584-1.034l-6.479 5.04a5.141 5.141 0 0 0 -1.568 6.08l.871 2.033a3.128 3.128 0 0 1 -.254 2.946l-1.096 1.691c-.027.044-.049.084-.143.044s-.079-.083-.068-.135a9.978 9.978 0 0 0 -4.221-10.4 2.944 2.944 0 0 1 -1.206-2.679l.773-7.73a1 1 0 0 0 -1.7-.807l-7.385 7.383a5.057 5.057 0 0 0 -.5 6.683 2.924 2.924 0 0 1 .165 3.482l-.644.967-.271-.338a5.736 5.736 0 0 0 -2.669-1.862 3.743 3.743 0 0 1 -2.322-4.867l1.272-3.39a1 1 0 0 0 -1.644-1.058l-7.387 7.383a5.057 5.057 0 0 0 -.5 6.683 2.924 2.924 0 0 1 .165 3.482l-.381.571c-.027-.05-.054-.1-.083-.149l-3.24-5.753a1 1 0 0 0 -1.864.373l-1.615 13.729a15.778 15.778 0 0 0 .135 4.6 1 1 0 0 0 .984.827z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.766 49h.234a1 1 0 0 0 .848-1.53l-1.57-2.511a1 1 0 0 0 .554-1.514l-4-6a1.039 1.039 0 0 0 -1.664 0l-1.168 1.755-2.132-3.2h2.132a1 1 0 0 0 .8-1.6l-3.2-4.265c.054.009.1.025.158.032a4.617 4.617 0 0 0 3.394-.924 6.329 6.329 0 0 1 -.229 3.012 1 1 0 0 0 .634 1.265.99.99 0 0 0 .315.052 1 1 0 0 0 .949-.685 8.588 8.588 0 0 0 -.15-5.705l-.131-.372a1 1 0 0 0 -1.84-.11 2.648 2.648 0 0 1 -4.974-.594l-.831-3.837a9.009 9.009 0 0 0 -1.658-3.042 1 1 0 0 0 -1.769.61 8.118 8.118 0 0 1 -1.315 4.194 37.014 37.014 0 0 1 -2.435 3.308 1.027 1.027 0 0 0 -1.54.1l-2.666 3.911-2.412-3.214a20.058 20.058 0 0 0 -3.27-12.691 1 1 0 0 0 -1.8.312l-1.03 4.106a18.052 18.052 0 0 1 -2.185 5.155 1 1 0 0 0 1.7 1.055 20.039 20.039 0 0 0 2.424-5.725l.425-1.7a18.093 18.093 0 0 1 1.8 7.406 1 1 0 0 0 -.965.343l-3.712 4.95-2.661-3.912a1.039 1.039 0 0 0 -1.654 0l-.25.367-.19-.238a36.663 36.663 0 0 0 -6.283-6.161 1 1 0 0 0 -1.219 1.586 34.572 34.572 0 0 1 5.94 5.825l.575.719-.758 1.115-3.187-4.248a1.036 1.036 0 0 0 -1.6 0l-6 8a1 1 0 0 0 .8 1.6h2.132l-2.132 3.2-1.168-1.755a1.039 1.039 0 0 0 -1.664 0l-4 6a1 1 0 0 0 .554 1.514l-1.57 2.511a1 1 0 0 0 .848 1.53h.234l-2.091 3.485a1 1 0 0 0 .857 1.515h3v4a1 1 0 0 0 2 0v-4h2v4a1 1 0 0 0 2 0v-4h2v7a1 1 0 0 0 2 0v-7h2v7a1 1 0 0 0 2 0v-7h2v4a1 1 0 0 0 2 0v-4h5v7a1 1 0 0 0 2 0v-7h2v7a1 1 0 0 0 2 0v-7h5v4a1 1 0 0 0 2 0v-4h2v7a1 1 0 0 0 2 0v-7h2v7a1 1 0 0 0 2 0v-7h2v4a1 1 0 0 0 2 0v-4h2v4a1 1 0 0 0 2 0v-4h3a1 1 0 0 0 .857-1.515zm-7.251-4h4.431l1.254 2h-4.257zm2.485-5.2 2.132 3.2h-1.6l-1.332-2zm-1.868 3.2h-12.264l4.667-7h2.93zm-15.617 2h3.971l-1.986 2.78zm-13.015 2.78-1.986-2.78h3.972zm1.368-4.78 4.667-7h2.93l4.667 7zm17.132-9 4-5.333 4 5.333zm1.826-8.877a10.126 10.126 0 0 0 1.129-2.35v.011l.713 3.308a.914.914 0 0 0 -.472.308l-3.188 4.251-1.105-1.626a39.683 39.683 0 0 0 2.923-3.902zm-4.826 4.655 1.743 2.565-1.543 2.057a1 1 0 0 0 .8 1.6h2.132l-3.632 5.447-3.632-5.447h2.132a1 1 0 0 0 .8-1.6l-1.019-1.358zm-8-1.111 4 5.333h-8zm-8 1.111 2.219 3.264-1.019 1.358a1 1 0 0 0 .8 1.6h2.132l-3.632 5.447-3.632-5.447h2.132a1 1 0 0 0 .8-1.6l-1.543-2.057zm-7-1.111 4 5.333h-8zm1.465 7.333 4.667 7h-12.264l4.667-7zm-8.408 11h-4.252l1.249-2h4.432zm-1.057-7.2.8 1.2-1.335 2h-1.6zm-4.233 12.2 1.8-3h2.062l-2.143 3zm4.176 0 5-7h6.114l3.214 4.5-1.785 2.5zm15 0 5-7h6.115l5 7zm18.571 0-1.785-2.5 3.214-4.5h6.115l5 7zm15 0-2.142-3h2.062l1.8 3z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWildfire);
export default __webpack_public_path__ + "static/media/wildfire.92a83864.svg";
export { ForwardRef as ReactComponent };